<template>
  <!-- 添加/编辑新人充值任务 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="dialogType === 1 ? '添加充值任务' : '编辑充值任务'"
      width="630px"
      @close="closeDialog"
    >
      <el-form
        :model="taskForm"
        v-if="taskForm"
        ref="taskForm"
        label-width="80px"
        size="small"
        :rules="taskRules"
      >
        <el-form-item prop="title" label="标题">
          <el-input
            style="width: 350px"
            v-model="taskForm.title"
            placeholder="请输入标题(请勿写钻石2字)"
          ></el-input>
        </el-form-item>
        <el-form-item prop="satisfaction" label="充值金额">
          <el-input
            style="width: 210px"
            v-model="taskForm.satisfaction"
            placeholder="请输入充值金额"
          ></el-input>
        </el-form-item>
        <el-form-item prop="day_within" label="注册天数">
          <el-input
            style="width: 210px"
            v-model="taskForm.day_within"
            placeholder="请输入注册天数"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="user_recharge_config_probabilities"
          label="奖励金额"
        >
          <p
            class="text-line"
            style="margin-bottom: 10px"
            v-for="(item, index) in taskForm.user_recharge_config_probabilities"
            :key="index"
          >
            概率{{ index + 1 }}：
            <el-input
              style="width: 100px"
              v-model="item.probability"
              placeholder="概率"
            ></el-input>
            ——
            <el-input
              style="width: 100px"
              v-model="item.min_amount"
              placeholder="最小金额"
            ></el-input>
            —
            <el-input
              style="width: 100px"
              v-model="item.max_amount"
              placeholder="最大金额"
            ></el-input>
            <i
              v-if="taskForm.user_recharge_config_probabilities.length > 1"
              class="el-icon-remove-outline reduce_btn"
              @click="reduceTextLine(index)"
            ></i>
            <i
              v-if="
                taskForm.user_recharge_config_probabilities.length - 1 === index
              "
              class="el-icon-circle-plus-outline add_btn"
              @click="addTextLine"
            ></i>
          </p>
        </el-form-item>
        <el-form-item prop="reward_show" label="显示金额">
          <el-input
            style="width: 300px"
            v-model="taskForm.reward_show"
            placeholder="请输入显示金额(范围请用 ~ 隔开)"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="weight" label="任务权重">
          <el-input style="width: 210px" v-model="taskForm.weight"></el-input>
        </el-form-item> -->
        <el-form-item prop="status" label="状态">
          <el-select v-model="taskForm.status" placeholder="请选择状态">
            <el-option :value="1" label="正常"></el-option>
            <el-option :value="2" label="关闭"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      taskForm: {//任务表单
        title: '',//标题
        satisfaction: '',//金额
        day_within: '',//注册天数
        user_recharge_config_probabilities: [{ probability: '', min_amount: '', min_amount: '' }],//当behavior为4、5、6时,
        reward_show: '',//前端显示金额
        status: 1,//状态 1正常 2关闭
        weight: '',//权重
      },
      taskRules: {//任务表单验证
        title: [
          {
            required: true,
            message: '请输入任务完整名称',
            trigger: 'blur'
          }
        ],
        satisfaction: [
          {
            required: true,
            message: '请输入充值金额',
            trigger: 'blur'
          }
        ],
        day_within: [
          {
            required: true,
            message: '请输入注册天数',
            trigger: 'blur'
          }
        ],
        user_recharge_config_probabilities: [
          {
            required: true,
            message: '请输入奖励金额',
            trigger: 'blur'
          }
        ],
        reward_show: [
          {
            required: true,
            message: '请输入显示金额',
            trigger: 'blur'
          }
        ],
        weight: [
          {
            required: true,
            message: '请输入任务权重',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    taskInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.type
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.taskInfo) {
        this.taskForm = this.taskInfo
      } else {
        //还原任务表单
        this.taskForm = {
          title: '',//标题
          satisfaction: '',//金额
          day_within: '',//注册天数
          user_recharge_config_probabilities: [{ probability: '', min_amount: '', min_amount: '' }],//当behavior为4、5、6时,
          reward_show: '',//前端显示金额
          status: 1,//状态 1正常 2关闭
          weight: '',//权重
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.$refs['taskForm'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.taskForm

          if (this.dialogType == 1) {
            postApiData('welfare_new_user', params).then(res => {
              if (res.code) {
                this.$message.success(res.message)
                this.closeDialog()//关闭弹窗
                this.$emit("refresh")//刷新数据
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType == 2) {
            patchApiData(`welfare_new_user/${params.id}`, params).then(res => {
              if (res.code) {
                this.$message.success(res.message)
                this.closeDialog()//关闭弹窗
                this.$emit("refresh")//刷新数据
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })
    },
    addTextLine() {
      //加行
      let params = { probability: '', min_amount: '', min_amount: '' }
      this.taskForm.user_recharge_config_probabilities.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.taskForm.user_recharge_config_probabilities.splice(num, 1)
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
      setTimeout(() => {
        if (this.dialogType == 2) {
          this.taskForm = {//还原任务表单
            title: '',//标题
            satisfaction: '',//金额
            day_within: '',//注册天数
            user_recharge_config_probabilities: [{ probability: '', min_amount: '', min_amount: '' }],//当behavior为4、5、6时,
            reward_show: '',//前端显示金额
            status: 1,//状态 1正常 2关闭
            weight: '',//权重
          }
        }
      }, 500)
    }
  }

}
</script>
<style lang="less" scoped>
</style>